import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_9940c66a from 'nuxt_plugin_head_9940c66a' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_38bd6e56 from 'nuxt_plugin_plugin0_38bd6e56' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_38bc8598 from 'nuxt_plugin_plugin1_38bc8598' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_38bb9cda from 'nuxt_plugin_plugin2_38bb9cda' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_38bab41c from 'nuxt_plugin_plugin3_38bab41c' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_38b9cb5e from 'nuxt_plugin_plugin4_38b9cb5e' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_38b8e2a0 from 'nuxt_plugin_plugin5_38b8e2a0' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_38b7f9e2 from 'nuxt_plugin_plugin6_38b7f9e2' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_38b71124 from 'nuxt_plugin_plugin7_38b71124' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_38b62866 from 'nuxt_plugin_plugin8_38b62866' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_38b53fa8 from 'nuxt_plugin_plugin9_38b53fa8' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_ded41fac from 'nuxt_plugin_plugin10_ded41fac' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_ded336ee from 'nuxt_plugin_plugin11_ded336ee' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_ded24e30 from 'nuxt_plugin_plugin12_ded24e30' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_ded16572 from 'nuxt_plugin_plugin13_ded16572' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_ded07cb4 from 'nuxt_plugin_plugin14_ded07cb4' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_decf93f6 from 'nuxt_plugin_plugin15_decf93f6' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_deceab38 from 'nuxt_plugin_plugin16_deceab38' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_decdc27a from 'nuxt_plugin_plugin17_decdc27a' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_deccd9bc from 'nuxt_plugin_plugin18_deccd9bc' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_decbf0fe from 'nuxt_plugin_plugin19_decbf0fe' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_deb7f0aa from 'nuxt_plugin_plugin20_deb7f0aa' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_deb707ec from 'nuxt_plugin_plugin21_deb707ec' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_deb61f2e from 'nuxt_plugin_plugin22_deb61f2e' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_deb53670 from 'nuxt_plugin_plugin23_deb53670' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_deb44db2 from 'nuxt_plugin_plugin24_deb44db2' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_9940c66a === 'function') {
    await nuxt_plugin_head_9940c66a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_38bd6e56 === 'function') {
    await nuxt_plugin_plugin0_38bd6e56(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_38bc8598 === 'function') {
    await nuxt_plugin_plugin1_38bc8598(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_38bb9cda === 'function') {
    await nuxt_plugin_plugin2_38bb9cda(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_38bab41c === 'function') {
    await nuxt_plugin_plugin3_38bab41c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_38b9cb5e === 'function') {
    await nuxt_plugin_plugin4_38b9cb5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_38b8e2a0 === 'function') {
    await nuxt_plugin_plugin5_38b8e2a0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_38b7f9e2 === 'function') {
    await nuxt_plugin_plugin6_38b7f9e2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_38b71124 === 'function') {
    await nuxt_plugin_plugin7_38b71124(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_38b62866 === 'function') {
    await nuxt_plugin_plugin8_38b62866(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_38b53fa8 === 'function') {
    await nuxt_plugin_plugin9_38b53fa8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_ded41fac === 'function') {
    await nuxt_plugin_plugin10_ded41fac(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_ded336ee === 'function') {
    await nuxt_plugin_plugin11_ded336ee(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_ded24e30 === 'function') {
    await nuxt_plugin_plugin12_ded24e30(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_ded16572 === 'function') {
    await nuxt_plugin_plugin13_ded16572(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_ded07cb4 === 'function') {
    await nuxt_plugin_plugin14_ded07cb4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_decf93f6 === 'function') {
    await nuxt_plugin_plugin15_decf93f6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_deceab38 === 'function') {
    await nuxt_plugin_plugin16_deceab38(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_decdc27a === 'function') {
    await nuxt_plugin_plugin17_decdc27a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_deccd9bc === 'function') {
    await nuxt_plugin_plugin18_deccd9bc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_decbf0fe === 'function') {
    await nuxt_plugin_plugin19_decbf0fe(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_deb7f0aa === 'function') {
    await nuxt_plugin_plugin20_deb7f0aa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_deb707ec === 'function') {
    await nuxt_plugin_plugin21_deb707ec(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_deb61f2e === 'function') {
    await nuxt_plugin_plugin22_deb61f2e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_deb53670 === 'function') {
    await nuxt_plugin_plugin23_deb53670(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_deb44db2 === 'function') {
    await nuxt_plugin_plugin24_deb44db2(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
